import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import reportslogo from "../../assets/images/reportslogo.png";
import CustomBarChart from "../commoncomponents/CustomBarChart";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  getAuthToken,
  getcompanyId,
  getFacilityId,
  getuserId,
} from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import axios from "axios";
import "../commoncomponents/print.css"; // Import the print CSS
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { defaultLightTheme } from "../../assets/styled-components/themes/themelist";
import { useSelector } from "react-redux";
import "jspdf-autotable";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const StaffReportView = forwardRef(
  (
    {
      setOpenModal,
      data,
      level,
      hospitalOptions = [],
      hospital,
      year,
      month,
      onRenderComplete,
      isPerformance,
      setIsView,
    },
    ref
  ) => {
    const [columns, setColumns] = useState([]);
    const printRef = useRef(null);
    const { color } = useSelector((state) => state.theme);
    const token = getAuthToken("id_token");
    const facilityId = getFacilityId("facilityId");

    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, `${isPerformance ? "SDRT002" : "SDRT003"}`);

    const performanceHeaders = [
      "Hospital Name",
      "Staff Name",
      "Staff Id",
      "W1",
      "W2",
      "W3",
      "W4",
      "W5",
      "W6",
      "W7",
      "W8",
      "W9",
      "W10",
      "W11",
      "W12",
      "Total Count",
    ];
    const efficiencyHeaders = [
      "Hospital Name",
      "Staff Name",
      "Staff ID",
      "Number of Service Request",
      "Completed",
      "Pending",
      "Efficiency",
    ];

    useEffect(() => {
      if (isPerformance) {
        fetchDesc();
      } else {
        setColumns(efficiencyHeaders);
      }
    }, [isPerformance]);

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const fetchDesc = async () => {
      try {
        const [workgroupResponseBems, workgroupResponseFems] =
          await Promise.all([
            axios.get(
              `${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`,
              config
            ),
            axios.get(
              `${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`,
              config
            ),
          ]);
        setColumns(
          mergeColumnsWithDescriptions(
            performanceHeaders,
            workgroupResponseBems.data,
            workgroupResponseFems.data
          )
        );
        console.log(mergeColumnsWithDescriptions, "  mergeColumnsWithDescriptions")
      } catch (err) {
        console.error("Error fetching descriptions:", err);
      }
    };

    const mergeColumnsWithDescriptions = (columns, array1, array2) => {
      return columns.map((col) => {
        const match1 = array1.find((item) => item.wgcode === col);
        const match2 = array2.find((item) => item.wgcode === col);
        const desc = match1?.wgdesc || match2?.wgdesc || "";
        return desc ? `${col}-${desc}` : col;
      });
    };

    useEffect(() => {
      if (onRenderComplete) {
        onRenderComplete();
      }
    }, [onRenderComplete]);

    const otherSetting = {
      height: 400,
      width: 1100,
      yAxis: [
        {
          label: isPerformance ? "Total WO Numbers" : "Efficiency(%)",
          marginLeft: 10,
        },
      ],
      grid: { horizontal: true },
      margin: { bottom: 200 },
    };

    const handlePrint = useReactToPrint({
      content: () => printRef.current,
    });

    const headerText = columns.filter((header) => header.includes("-"))
      .map((header) => {
        const [abbreviation, description] = header.split("-");
        return `[${abbreviation.trim()} - ${description.trim()}]`;
      })
      .join(" ");

    const handleDownloadPDF = async () => {
      const pdf = new jsPDF("p", "pt", "a4");

      const logo = new Image();
      logo.src = reportslogo;

      logo.onload = async () => {
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 40;

        pdf.addImage(logo, "PNG", (pageWidth - 60) / 2, 30, 60, 60);

        const reportTitle = `Staff ${isPerformance ? "Performance" : "Efficiency"} Report`;

        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(14);
        const titleWidth = pdf.getTextWidth(reportTitle);
        pdf.text(reportTitle, (pageWidth - titleWidth) / 2, 120);

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(10);

        const hospitalText = `Hospital Name: ${level?.label === "HQ" ? "HeadQuarters" : hospital?.value}`;
        const monthYearText = `Month/Year: ${month?.value === 0 ? "All" : month?.value}/${year?.value}`;

        pdf.text(hospitalText, margin, 150);
        pdf.text(monthYearText, margin, 170);

        const columns = isPerformance ? performanceHeaders : efficiencyHeaders;

        const rows = data.map((row) =>
          isPerformance
            ? [
              row.hospitalName, row.employeeName, row.employeeId,
              row.countW1, row.countW2, row.countW3, row.countW4, row.countW5, row.countW6,
              row.countW7, row.countW8, row.countW9, row.countW10, row.countW11, row.countW12,
              row.totalCount,
            ]
            : [
              row.hospitalName, row.employeeName, row.employeeId,
              row.totalCount, row.completedcount, row.pendingCount, `${row.completedPercentage}%`,
            ]
        );

        const columnStyles = {
          0: { fontStyle: "bold", halign: "left" },
          1: { fontStyle: "bold", halign: "left" },
          2: { fontStyle: "bold", halign: "left" },
        };

        columns.forEach((_, index) => {
          if (index > 2) {
            columnStyles[index] = { halign: "right" };
          }
        });

        let finalTableY = 190; // Track final Y position after the table

        pdf.autoTable({
          startY: finalTableY,
          head: isPerformance
            ? [[{
              content: headerText,
              colSpan: columns.length,
              styles: {
                halign: "center",
                cellWidth: "auto",
                overflow: "linebreak",
                minCellHeight: 20,
              },
            }], columns]
            : [columns],
          body: rows,
          theme: "grid",
          headStyles: {
            fillColor: [185, 149, 213],
            textColor: 255,
            fontStyle: "bold",
            minCellHeight: 25,
            lineWidth: 0.5,
            lineColor: 255,
          },
          styles: { overflow: "linebreak", fontSize: 8 },
          margin: { top: 30 },
          rowPageBreak: "avoid",
          columnStyles,
          didDrawPage: (data) => {
            const pageNumber = pdf.internal.getNumberOfPages();
            pdf.setFontSize(8);
            pdf.text(`Page ${pageNumber}`, pageWidth - 70, pageHeight - 30);
            finalTableY = data.cursor.y; // Track the last Y position
          },
        });

        const chartElement = document.querySelector(".chart-section");
        if (chartElement) {
          try {
            const chartCanvas = await html2canvas(chartElement, { scale: 2 });
            const chartImage = chartCanvas.toDataURL("image/png");

            let chartYPosition = finalTableY + 30;
            let remainingSpace = pageHeight - chartYPosition - 50;

            if (remainingSpace < 300) {
              pdf.addPage();
              chartYPosition = margin;
            }

            pdf.addImage(chartImage, "PNG", margin, chartYPosition, pageWidth - (margin * 2), 300);

            // Ensure the page number is drawn at the bottom after the chart
            const pageNumber = pdf.internal.getNumberOfPages();
            pdf.setFontSize(8);
            pdf.text(`Page ${pageNumber}`, pageWidth - 70, pageHeight - 30);
          } catch (error) {
            console.error("Error capturing chart image:", error);
          }
        }

        pdf.save(`Staff${isPerformance ? "Performance" : "Efficiency"}Report.pdf`);

      };
    };

    const handleClose = () => {
      setIsView(false);
      setOpenModal(false);
    };

    useImperativeHandle(ref, () => ({
      handleDownloadPDF,
    }));

    return (
      <MuiThemeProvider
        theme={{
          ...defaultLightTheme,
          palette: {
            ...defaultLightTheme.palette,
            background: {
              default: color !== "default" && "rgba(17, 17, 17, 1)",
            },
          },
        }}
      >
        <CssBaseline />
        <Stack
          direction="row"
          justifyContent="end"
          alignItems="center"
          gap={2}
          mt={2}
        >
          {access?.canPrint && (<>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#A77BCA" }}
              onClick={handlePrint}
            >
              Print
            </Button>
            <Button variant="contained" onClick={handleDownloadPDF}>
              Download
            </Button>
          </>)}
          <Button variant="contained" onClick={handleClose}>
            Close
          </Button>
        </Stack>
        <Box ref={printRef} className="staff-report-print">
          <Box className="table-section">
            <Box textAlign="center">
              <img src={reportslogo} alt="logo" width={"8%"} />
            </Box>
            <Box textAlign="center">
              <Typography variant="title1">
                Staff {isPerformance ? " Performance" : "Efficiency"} Report
              </Typography>
            </Box>
            <Stack>
              <Typography variant="subtitle2">
                Hospital Name :{" "}
                {level?.label === "HQ" ? "HeadQuaters" : hospital?.value}
              </Typography>
              <Typography variant="subtitle2">
                Month/Year : {month?.value === 0 ? "All" : month?.value}/{year?.value}
              </Typography>
            </Stack>
            <TableContainer
              component={Paper}
              sx={!data.length > 0 && { width: "1100px" }}
            >
              <Table>
                <TableHead
                  sx={{ backgroundColor: "#B995D5" }} // Set the background color for the header
                >
                  {/* First Header Row */}
                  {isPerformance ? (
                    <>
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          {columns
                            .filter((header) => header.includes("-"))
                            .map((header, index) => {
                              const [abbreviation, description] =
                                header.split("-");
                              return (
                                <span
                                  key={index}
                                  style={{
                                    display: "inline-block",
                                    whiteSpace: "nowrap",
                                    marginRight: "10px",
                                    color: "white",
                                  }}
                                >
                                  [<strong>{abbreviation}</strong> -{" "}
                                  {description}]
                                </span>
                              );
                            })}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        {performanceHeaders.map((header, index) => (
                          <TableCell
                            key={index}
                            sx={{ fontWeight: "bold", color: "white" }} // Set text color to white
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      {efficiencyHeaders.map((header, index) => (
                        <TableCell
                          key={index}
                          sx={{ fontWeight: "bold", color: "white" }} // Set text color to white
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  )}
                </TableHead>

                <TableBody>
                  {data.length > 0 ? (
                    data.map((row) => (
                      <TableRow key={`${row.hospitalId}-${row.employeeId}`}>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {row.hospitalName}
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>{row.employeeName}</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>{row.employeeId}</TableCell>

                        {/* Render Performance Data */}
                        {isPerformance ? (
                          <>
                            <TableCell align="right">{row.countW1}</TableCell>
                            <TableCell align="right">{row.countW2}</TableCell>
                            <TableCell align="right">{row.countW3}</TableCell>
                            <TableCell align="right">{row.countW4}</TableCell>
                            <TableCell align="right">{row.countW5}</TableCell>
                            <TableCell align="right">{row.countW6}</TableCell>
                            <TableCell align="right">{row.countW7}</TableCell>
                            <TableCell align="right">{row.countW8}</TableCell>
                            <TableCell align="right">{row.countW9}</TableCell>
                            <TableCell align="right">{row.countW10}</TableCell>
                            <TableCell align="right">{row.countW11}</TableCell>
                            <TableCell align="right">{row.countW12}</TableCell>
                            <TableCell align="right">{row.totalCount}</TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell align="right">{row.totalCount}</TableCell>
                            <TableCell align="right">{row.completedcount}</TableCell>
                            <TableCell align="right">{row.pendingCount}</TableCell>
                            <TableCell align="right">{row.completedPercentage}%</TableCell>
                          </>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        No Records Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {data.length > 0 && (
            <Box className="chart-section" sx={{ marginLeft: "50px" }}>
              {isPerformance ? (
                <CustomBarChart
                  dataset={data}
                  xDataKey={"employeeName"}
                  yDataKey={"totalCount"}
                  label={"Total WO Numbers"}
                  otherSetting={otherSetting}
                  verticalLabels={true}
                />
              ) : (
                <>
                  <CustomBarChart
                    dataset={data}
                    xDataKey={"employeeName"}
                    yDataKey={"completedPercentage"}
                    otherSetting={otherSetting}
                    verticalLabels={true}
                  />
                </>
              )}
            </Box>
          )}
        </Box>
      </MuiThemeProvider>
    );
  }
);

export default StaffReportView;
